import { createContext, ReactNode, useContext, useState } from "react";

type NotificationContextValues = {
  isNotification: boolean;
  title: string;
  message: string;
  isVisible: boolean;
  onClose: () => void;
  setNotification: (
    notificationTitle: string,
    notificationMessage: string,
    isInformative?: boolean
  ) => void;
};

export const NotificationContext = createContext(
  {} as NotificationContextValues
);

export const useNotificationContext = () => useContext(NotificationContext);

export const NotificationContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isNotification, setIsNotification] = useState(true);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [isVisible, setIsVisible] = useState(false);

  const setNotification = (
    notificationTitle: string,
    notificationMessage: string,
    isInformative: boolean = true
  ) => {
    setIsVisible(true);
    setIsNotification(isInformative);
    setTitle(notificationTitle);
    setMessage(notificationMessage);
  };

  const onClose = () => {
    setIsVisible(false);
  };

  return (
    <NotificationContext.Provider
      value={{
        isNotification,
        title,
        message,
        isVisible,
        onClose,
        setNotification,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
